// extracted by mini-css-extract-plugin
module.exports = {"forgotPasswordPage":"forgotPassword_forgotPasswordPage__2zNUO"};